// import i18n from '@/lang/lang'
// import router from '@/router'
const debug = require('debug')('OD::Lib:MatchPointHelper')

const libLogs = false

export default {
  config(sport) {
    const base = { type: sport.type || 'baseballBase' }
    return Object.assign(base, {
      sportId: sport.id,
      sport: sport.sport || '',
      name: sport.name,
      pointControls: sport.pointControls || [{ text: '', description: '', num: 1 }],
      pointBasicControls: sport.pointBasicControls || [{ text: '', description: '', num: 1 }],
      minNumInnings: parseInt(sport.minNumInnings),
      downtimeBySet: parseInt(sport.downtimeBySet),
      actionControls: sport.actionControls || [],
      actionBasicControls: sport.actionBasicControls || [],
      timeControls: sport.timeControls || [],
      globalControls: sport.globalControls || [],
      num: sport.num || 0,
      opposite: sport.opposite || false,
      maxPlayerNum: parseInt(sport.maxPlayerNum),
      numPlayerInSet: parseInt(sport.numPlayerInSet),
      numExtraPlayerInSet: parseInt(sport.numExtraPlayerInSet),
      maxFaultsBySet: parseInt(sport.maxFaultsBySet),
      numOuts: 3,
    })
  },
  matchSetEnd(config, set, i) {
    if (libLogs) debug('matchSetEnd', { config, set, i })
    let ended = false
    let numOutsLocal = 0
    let numOutsVisitor = 0
    if (set.events && set.events.length > 0) {
      numOutsLocal = set.events.filter(event => event.action === 'out' && event.team === 'l').length
      numOutsVisitor = set.events.filter(event => event.action === 'out' && event.team === 'v')
        .length
      if (set.events.filter(event => event.action === '3outs' && event.team === 'l').length >= 1) {
        numOutsLocal = config.numOuts
      }
      if (set.events.filter(event => event.action === '3outs' && event.team === 'v').length >= 1) {
        numOutsVisitor = config.numOuts
      }
    }
    ended = numOutsLocal >= config.numOuts && numOutsVisitor >= config.numOuts
    return ended
  },
  getMatchResult(config, match) {
    if (libLogs) debug('getMatchResult', { config, match })
    let localResult = 0
    let visitorResult = 0
    if (match.sets) {
      match.sets.map((set, i) => {
        localResult += set.l
        visitorResult += set.v
      })
    }
    return { l: localResult, v: visitorResult }
  },
  isMatchOnline(config, match, matchFinish) {
    if (libLogs) debug('isMatchOnline', { config, match, matchFinish })
    let inPlay = false
    match.sets.map(set => {
      if (set.events && set.events.length > 0) {
        inPlay = true
      }
    })
    if (inPlay) {
      return !matchFinish
    }
    return false
  },
  isMatchStarted(config, match) {
    if (libLogs) debug('isMatchStarted', { config, match })
    let inPlay = false
    match.sets.map(set => {
      if (set.l > 0 || set.v > 0) {
        inPlay = true
      }
    })
    return inPlay
  },
  isMatchFinish(config, match, matchResult) {
    if (libLogs) debug('isMatchFinish', { config, match })
    const lastSet = match.sets[match.sets.length - 1]
    const lastSetEnd = this.matchSetEnd(config, lastSet, null)

    if (lastSet.events && lastSet.events.length > 0) {
      const numOutsVisitor = lastSet.events.filter(
        event => event.action === 'out' && event.team === 'v'
      ).length
      const num3OutsVisitor = lastSet.events.filter(
        event => event.action === '3outs' && event.team === 'v'
      ).length
      if (numOutsVisitor >= 3 || num3OutsVisitor >= 1) {
        let localResult = 0
        let visitorResult = 0
        if (match.sets) {
          match.sets.map((set, i) => {
            localResult += set.l
            visitorResult += set.v
          })
        }
        if (localResult > visitorResult) {
          return true
        }
      }
    }

    return lastSetEnd && matchResult.l !== matchResult.v
  },
  isButtonDisabled(control, config, match, i, action, team, matchFinished) {
    if (libLogs)
      debug('isButtonDisabled', { control, config, match, i, action, team, matchFinished })
    if (!matchFinished) {
      const set = match.sets[i]

      if (action === 'remove') {
        if (i > 0) {
          return false
        } else {
          if (!set.events || set.events.length === 0) {
            return true
          }
        }
      } else {
        if (set.events && set.events.length > 0) {
          const numV = set.events.filter(event => event.action === 'out' && event.team === 'v')
            .length
          const numV3Outs = set.events.filter(
            event => event.action === '3outs' && event.team === 'v'
          ).length
          if (numV >= 3 || numV3Outs >= 1) {
            return team !== 'l'
          }
        }
        return team !== 'v'
      }
      if (!this.matchSetEnd(config, set, i)) {
        return false
      }
      return true
    } else {
      if (action === 'remove') {
        if (i > 0) {
          return false
        }
      }
      return true
    }
  },
  getMaxNumDowntimesBySet(config) {
    if (libLogs) debug('getMaxNumDowntimesBySet', { config })
    return config.downtimeBySet
  },
}
